const PRINCIPLES = [
  { idx: '01', title: 'Purposeful Giving' },
  { idx: '02', title: 'Community Well-Being' },
  { idx: '03', title: 'Long-Term Impact' },
];

export default function MissionPanel() {
  return (
    <section className="panel" data-side="left" id="mission" aria-labelledby="mission-heading">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Sunlit%20architectural%20interior%20with%20a%20tall%20arched%20window%20and%20deep%20sage%20green%20plaster%20wall%2C%20long%20geometric%20bands%20of%20warm%20morning%20light%20crossing%20a%20pale%20stone%20floor%2C%20a%20simple%20oak%20bench%2C%20calm%20empty%20room%2C%20soft%20shadows%2C%20refined%20editorial%20architecture%20photography%20with%20muted%20earthy%20tones%20and%20no%20people&width=2400&height=1350&seq=reve-mission-window&orientation=landscape"
        alt="A sunlit room with an arched window casting long bands of light across a pale stone floor."
        width="2400"
        height="1350"
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" aria-hidden="true" />
      <span className="panel-accent numeral" data-parallax="0.55" aria-hidden="true">
        01
      </span>

      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          02 — Our mission
        </p>
        <h2 id="mission-heading" data-reveal>
          Purpose that
          <br />
          makes a <em className="accent">difference.</em>
        </h2>
        <p className="sub" data-reveal>
          We believe that thoughtful philanthropy can help strengthen communities and support
          organizations working toward meaningful, lasting change. Our approach emphasizes
          responsible giving, careful consideration, and a long-term perspective on charitable
          impact.
        </p>

        <div className="principles">
          {PRINCIPLES.map((p) => (
            <div className="principle" key={p.idx} data-reveal>
              <span className="idx">{p.idx}</span>
              <span className="ttl">{p.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}